// @ts-strict-ignore
import { useState } from 'react'

declare global {
  interface Window {
    grecaptcha: any
  }
}

const recaptchaApiUrl: string = process.env.RECAPTCHA_API_URL
const recaptchaSitekey: string = process.env.RECAPTCHA_SITEKEY_V3
const recaptchaSrc = `${recaptchaApiUrl}?render=${recaptchaSitekey}`

export const useRecaptcha = (action: string) => {
  const [isLoadingRecaptcha, setIsLoadingRecaptcha] = useState(true)

  const getRecaptchaToken = async (): Promise<string> => {
    return new Promise((resolve, reject) => {
      window.grecaptcha?.ready(() => {
        try {
          window.grecaptcha
            .execute(recaptchaSitekey, { action })
            .then((token: string) => resolve(token))
        } catch (error) {
          reject(error)
        }
      })
    })
  }

  const getLoadedRecaptcha = () => document.querySelectorAll(`script[src="${recaptchaSrc}"]`)

  const removeBadges = () => {
    const badges = document.querySelectorAll('.grecaptcha-badge')
    if (!badges?.length) return
    badges?.forEach(badge => badge.parentElement.remove())
  }

  const loadRecaptcha = () => {
    const loaded = getLoadedRecaptcha()
    if (!!loaded?.length) {
      setIsLoadingRecaptcha(false)
      return
    }

    const script = document.createElement('script')
    script.src = recaptchaSrc
    document.body.appendChild(script)
    setIsLoadingRecaptcha(false)
  }

  const unloadRecaptcha = () => {
    const loaded = getLoadedRecaptcha()
    if (!loaded?.length) return
    loaded?.forEach(load => load.remove())
    removeBadges()
  }

  return {
    isLoadingRecaptcha,
    loadRecaptcha,
    unloadRecaptcha,
    getRecaptchaToken,
  }
}
